import moment, { Moment } from 'moment';
import { useMemo } from 'react';

const usePartialSumHelp = ({
  startingDate,
  dueDate,
  endDate,
}: {
  startingDate: Moment | null;
  dueDate: Moment | null;
  endDate: Moment | null;
}) => {
  const help = useMemo(() => {
    if (moment(startingDate).isSameOrBefore(moment(dueDate).toDate()))
      return 'The starting date is earlier or equal to the due date ';
    if (moment(startingDate).isSameOrAfter(moment(endDate).toDate()))
      return 'The starting date is earlier or equal to the starting date ';
    return '';
  }, [endDate, dueDate, startingDate]);

  return help;
};

export default usePartialSumHelp;
